(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'googleEcomTracking';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("googleEcomTracking", TrackingModel);

        if (!Tracker)
            return;

        var CanTrack = LhApp.Function.Tracking.canTrack('statisticCookies');

        Init();
        
        function Init() {
            if (!CanTrack) return;

            if (!LhApp.Function.Tracking.InitGoogleTagManager()) {
                CanTrack = false;
                return;
            }

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        var oScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
                        var tracked = false;
                        if (oScope && !tracked) {
                            if (TrackingModel.IsThankYouPage) //cookie consent had been granted
                            {
                                tracked = true;

                                if (TrackingModel.CartProductsData.length <= 0)
                                    return;

                                window.dataLayer = window.dataLayer || [];

                                //Which dimensions will be used in the name.
                                var dimsInName = parseInt(Tracker.Properties.EcomTrackingDimensionsInName);

                                var products = [];
                                var discounts = [];
                                var brands = [];
                                var items = TrackingModel.CartProductsData;
                                for (var i = 0; i < items.length; i++) {
                                    var p = items[i];
                                    //var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                                    var sku = '{0}_{1}{2}'.format(
                                        p.ProductId,
                                        p.SkuId,
                                        p.ManufacturerProductCode ? '_' + p.ManufacturerProductCode : ''
                                    );
                                    var name = '{0} > {1}{2}{3}{4} {5}'.format(
                                        p.Brand ? p.Brand : "(Unbranded)",
                                        p.Path.length > 0 ? p.Path[p.Path.length - 1] : p.Name,
                                        p.Color && [1, 12, 13, 123].indexOf(dimsInName) >= 0 ? p.Color : '',
                                        p.Size && [2, 12, 23, 123].indexOf(dimsInName) >= 0 ? p.Size : '',
                                        p.Dim3 && [3, 13, 23, 123].indexOf(dimsInName) >= 0 ? p.Dim3 : '',
                                        p.ProductId
                                    );
                                    products[products.length] = {
                                        'sku': sku ,
                                        'name': name ,
                                        'category': p.Path.length < 2 ? '' : p.Path.slice(0, p.Path.length - 1).join(' > '),
                                        'price': p.PriceWithoutVatN,
                                        'quantity': p.Quantity
                                    };

                                    if (p.Brand && brands.indexOf(p.Brand) < 0)
                                        brands[brands.length] = p.Brand;
                                }

                                for (var discountType in TrackingModel.Order.Discounts) {
                                    var typeDiscounts = TrackingModel.Order.Discounts[discountType];
                                    for (var i = 0; i < typeDiscounts.length; i++) {
                                        var discount = typeDiscounts[i];

                                        if (discount.AmountN <= 0)
                                            continue;

                                        if (discountType == 'Order' && discount.IsSplitOnProducts)
                                            continue;

                                        discounts[discounts.length] = {
                                            'sku': discount.Coupon ? 'Coupon_{0}'.format(discount.Coupon) : 'Discount_{0}_{1}'.format(discountType, discounts.length),
                                            'name': discount.Name,
                                            'category': p.Path.length < 2 ? '' : p.Path.slice(0, p.Path.length - 1).join(' > '),
                                            'price': -1 * discount.AmountWithoutVatN,
                                            'quantity': 1
                                        };
                                    }
                                }

                                window.dataLayer.push({
                                    'transactionId': TrackingModel.Order.Code,
                                    'transactionAffiliation': LhApp.Context.Site.Name,
                                    'transactionTotal': TrackingModel.Order.ProductsCostWithouVatN,
                                    'transactionTax': TrackingModel.Order.VatCostN,
                                    'transactionShipping': TrackingModel.Order.ShippingCostWithoutVatN,
                                    'transactionProducts': products.concat(discounts)
                                });

                                window.dataLayer.push(brands.sort().join(','));
                            }
                        }
                    });
                }
            }
        }
    });
})();
